<div class="duna-event-instructors-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Instruktørinvitationer</h1></mat-card-title>
      <mat-card-subtitle>
        Find events der mangler instruktører, opret invitationer og fordel
        instruktører.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <mat-tab-group animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>Events der mangler instruktører</ng-template>
      <mat-card class="table-card">
        <mat-card-header>
          <mat-card-title>Kommende events uden instruktør</mat-card-title>
          <mat-card-subtitle>
            Vælg events og opret en instruktørinvitation. Toggle kan inkludere
            events der allerede har mindst én instruktør.
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="actions-row">
          <button
            mat-raised-button
            color="primary"
            [disabled]="selectedEventsCount === 0"
            (click)="openCreateInvitationModal()"
          >
            Opret instruktørinvitation @if (selectedEventsCount > 0) {
            <span> ({{ selectedEventsCount }} valgt)</span>
            }
          </button>
        </mat-card-content>
        <mat-card-content>
          <app-dynamic-table
            #eventsTable
            [dynamicInput]="{
              dataSource: { type: 'text', value: 'events_needing_instructors' }
            }"
          >
          </app-dynamic-table>
        </mat-card-content>
      </mat-card>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>Instruktørinvitationer</ng-template>
      <mat-card class="table-card">
        <mat-card-header>
          <mat-card-title>Alle instruktørinvitationer</mat-card-title>
          <mat-card-subtitle>
            Åbn en invitation for at se svar, fordeling og afslut.
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <app-dynamic-table
            #invitationsTable
            [dynamicInput]="{
              dataSource: { type: 'text', value: 'instructor_invitations_list' }
            }"
          >
          </app-dynamic-table>
        </mat-card-content>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
